var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16666 8.14943C8.16666 7.6892 8.53975 7.3161 8.99999 7.3161C9.46023 7.3161 9.83332 7.6892 9.83332 8.14943V13.1494C9.83332 13.6097 9.46023 13.9828 8.99999 13.9828C8.53975 13.9828 8.16666 13.6097 8.16666 13.1494V8.14943Z",
    fill: "#1A3D82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 4.04258C8.53975 4.04258 8.16666 4.41568 8.16666 4.87592C8.16666 5.33615 8.53975 5.70925 8.99999 5.70925C9.46023 5.70925 9.83332 5.33615 9.83332 4.87592C9.83332 4.41568 9.46023 4.04258 8.99999 4.04258Z",
    fill: "#1A3D82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99999 0.666626C4.39762 0.666626 0.666656 4.39759 0.666656 8.99996C0.666656 13.6023 4.39762 17.3333 8.99999 17.3333C13.6024 17.3333 17.3333 13.6023 17.3333 8.99996C17.3333 4.39759 13.6024 0.666626 8.99999 0.666626ZM2.33332 8.99996C2.33332 12.6819 5.31809 15.6666 8.99999 15.6666C12.6819 15.6666 15.6667 12.6819 15.6667 8.99996C15.6667 5.31806 12.6819 2.33329 8.99999 2.33329C5.31809 2.33329 2.33332 5.31806 2.33332 8.99996Z",
    fill: "#1A3D82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b16d52b2973000b0d448a3625698015f.svg";
export { ForwardRef as ReactComponent };